<template>
    <div class="monitoring-table">
        <ns-paginate
            class="monitoring-paginate"
            ref="monitoringPaginate"
            :customFiltersToApply="filterData"
            :baseUrl="baseUrl"
            :displayCsvButton="false"
        >
            <template slot="list" slot-scope="props">
                <el-table :data="props.list">
                    <el-table-column
                        prop="resource_name"
                        label="Resource name"
                    ></el-table-column>
                    <el-table-column
                        prop="level"
                        label="Status"
                    ></el-table-column>
<!--                     <el-table-column
                        label="AWS Flow"
                    >
                        <template slot-scope="scope">
                            <el-button class="gcmcn-primary-btn small" @click="openDetailsModal"></el-button>
                        </template>
                    </el-table-column>
 -->                </el-table>
            </template>
        </ns-paginate>
    </div>
</template>

<script>
import NsPaginate from 'fundation-app-vuejs/src/components/partials/nsPaginate';

export default {

    components: {
        NsPaginate
    },

    props: {
        baseUrl: {
            type: String,
            required: true
        }
    },

    data: function(){
        return {

        };
    },

    computed: {

    },

    mounted: function(){

    },

    methods: {
        filterData() {
            return {archived: 'false', c_resp_nested: 'true'};
        },

    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Monitoring/monitoring-table.vue